import axios from "axios";
import { PUBLIC_SESSION_CONFIG } from "./publicAccountSession";

export function getParagraphTopics() {
  return axios.get("/api/paragraph-practice/topics", PUBLIC_SESSION_CONFIG);
}

export function createParagraphSubmission({ topic_id, grade_level, paragraph, idempotencyKey }) {
  return axios.post("/api/paragraph-practice/submissions", { topic_id, grade_level, paragraph }, {
    ...PUBLIC_SESSION_CONFIG,
    headers: { "Content-Type": "application/json", "Idempotency-Key": idempotencyKey },
  });
}

export function getParagraphSubmission(statusUrl, submissionId) {
  const url = statusUrl || `/api/paragraph-practice/submissions/${encodeURIComponent(submissionId)}`;
  return axios.get(url, PUBLIC_SESSION_CONFIG);
}

export function paragraphPayload(response) {
  return response?.data?.data || response?.data || response || {};
}
